/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import * as React from 'react';
import {AbstractWizardState} from "./AbstractWizardState";
import {RegistrationStatusState} from "./RegistrationStatusState";
import {RegistrationProcess} from "../wizard/GatewayRegistration/RegistrationProcess";

/**
 * This models the registration stage of gateway management.
 * This state transition happens once a site is selected.
 */
export class RegistrationProcessState extends AbstractWizardState {

  /**
   * Get the content corresponding to the gateway registration
   * @returns {JSX.Element}
   */
  getContent(): JSX.Element {
    let state = this.page.state;
    return <RegistrationProcess
        gatewayValidationStore={this.page.props.gatewayValidationStore}
        enrollmentId={state.enrollmentId}
        epName={state.epName}
        serialNumber={state.serialNumber}
        deviceId={state.deviceId}
        siteDetails={this.page.state.selectedSite}
        onContactSupport={ () => this.page.launchContactSupport(this.page.state.registrationStatus) }
        gatewayRegistrationSuccess={(): void => {
          this.gatewayRegistrationSuccess();
        }}
        gatewayRegistrationFailed={(status: number): void => {
          this.gatewayRegistrationFailed(status);
        }}
      />;
  }

  /**
   * Callback when gateway RegistrationProgress is successful.
   * Transitions to the registration summary with success state
   */
  gatewayRegistrationSuccess = () => {
    this.page.setState({
      registrationStatus: new RegistrationStatusState(this.page, true)
    });
  };

  /**
   * Callback when gateway RegistrationProgress fails.
   * Transitions to the registration summary with error state
   */
  gatewayRegistrationFailed = (status: number) => {
    // Set a message explicitly when there is a 409 conflict
    let message = "";
    if (status === 409) {
      message = "Unable to register. The gateway is already associated to another site.";
    } else if (status === 500){
      message = "Unable to register. Customer ID is invalid.";
    }
    this.page.setState({
      registrationStatus: new RegistrationStatusState(this.page, false, message)
    });
  }

}
